export const setLocalStorageItem = (key, value) => {
  window.localStorage.setItem(key, value);
};

export const getLocalStorageItem = (key) => {
  return window.localStorage.getItem(key);
};

export const removeLocalStorageItem = (key) => {
  return window.localStorage.removeItem(key);
};
